module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Hero intro.0adc5cdc.png";